<template>
  <div class="bg-white">
    <div v-if="showFilters" class="row p-3">
      <div class="col-md-5 offset-md-7">
        <div class="form-group">
          <label>{{ $t('filter.filters') }}</label>
          <DateRangePicker v-model="selectedDateRange" />
          <small class="form-text">
            <span class="block">{{ $t('filter.selectedRange') }}:</span>
            <strong v-if="selectedDateRange">{{ selectedDateRangeFormatted }}</strong>
          </small>
        </div>
      </div>
    </div>
    <div v-if="groupsPerDay.length">
      <div v-for="(group, index) in groupsPerDay" :key="index">
        <ActivityItem :group="group" />
      </div>
    </div>
    <div v-else class="list-empty">
      <h4>{{ $t('previousResults.noHistory') }}</h4>
    </div>
  </div>
</template>
<script>
// import { mapGetters } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import DateRangePicker from '@/components/DateRangePicker';
import ActivityItem from './ActivityItem';

export default {
  name: 'ActivityList',
  components: {
    DateRangePicker,
    ActivityItem,
  },
  props: {
    studentId: {
      type: Number,
      required: true,
    },
    dateRange: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedDateRange: {
        from: null,
        to: null,
      },
      showFilters: true,
      groupsPerDay: [],
    };
  },
  computed: {
    // ...mapGetters({
    //   sessions: 'session/list',
    // }),
    selectedDateRangeFormatted() {
      if (this.selectedDateRange) {
        return (
          moment(this.selectedDateRange.from).format('L LT') + ' - ' + moment(this.selectedDateRange.to).format('L LT')
        );
      } else {
        return 'none';
      }
    },
  },
  watch: {
    selectedDateRange: function () {
      this.onFetchSessions();
    },
  },
  mounted() {
    if (this.dateRange) {
      this.selectedDateRange.from = this.dateRange.from;
      this.selectedDateRange.to = this.dateRange.to;
      this.onFetchSessions();
    }
  },
  methods: {
    onFetchSessions() {
      let term = 'date-range';
      let filters = {
        from: this.selectedDateRange.from,
        to: this.selectedDateRange.to,
        student_id: this.studentId,
      };

      let filtersJSON = JSON.stringify(filters);
      this.$httpMain
        .get(`lesson-tracking?term=${term}&filters=${filtersJSON}`)
        .then(res => {
          this.groupsPerDay = [];
          let groupsPerDay = _.groupBy(res.data, function (item) {
            return moment(item.created_at).startOf('day').format();
          });

          Object.entries(groupsPerDay).forEach(([key, value]) => {
            this.groupsPerDay.push({ date: key, items: value });
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.list-empty {
  // position: absolute;
  background-color: #fff;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  z-index: 9;
  // display: flex;
  // align-items: center;
  // justify-content: center;
}
.form-text {
  font-size: 13px;
}
</style>
